import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { DataGrid } from "@material-ui/data-grid";
import { Button, Modal, Form, Row, Col, InputGroup } from "react-bootstrap";
import SearchIcon from "@material-ui/icons/Search";
import * as Admin from "../../../store/ducks/admin.duck";
import { Formik } from "formik";
import * as Yup from "yup";
import {
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Grid,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  makeStyles,
} from "@material-ui/core";
import { ToastContainer, Flip } from "react-toastify";
import { format } from "date-fns";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../../_metronic/_assets/css/app.css";
import "../../../../_metronic/_assets/css/app2.css";

const useStyles = makeStyles((theme) => ({
  noBorder: {
    border: "none",
  },
  formControl: {
    margin: 0, //theme.spacing(1),
    minWidth: 120,
  },
  formControlWide: {
    margin: 0, //theme.spacing(1),
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  label: {
    backgroundColor: "#fff",
    paddingLeft: 3,
    paddingRight: 3,
  },
}));

export default function Opportunity() {
  const [searchTerm, setSearchTerm] = useState("");
  const filters = useSelector((state) => state.admin.Filters);
  const opportunities = useSelector((state) => state.admin.Opportunities);
  const [show, setShow] = useState(false);

  const [currentOpportunity, setCurrentOpportunity] = useState(null);

  const searchOpportunities = (opportunity) => {
    if (
      true &&
      (opportunity.description.toLowerCase().search(searchTerm.toLowerCase()) > -1 || searchTerm.length === 0) &&
      (!filters.opportunityStatus || (filters.opportunityStatus && opportunity.status === filters.opportunityStatus)) &&
      (!filters.opportunityType || filters.opportunityType === "All" || (filters.opportunityStatus && opportunity.type === filters.opportunityStatus))
    ) {
      return opportunity;
    }
  };

  const filteredOpportunities = opportunities.filter((opportunity) => searchOpportunities(opportunity));

  const dispatch = useDispatch();
  const classes = useStyles();
  useEffect(() => {
    dispatch(Admin.actions.fetchOpportunities());
  }, [dispatch]);

  const loadOpportunityDetail = (thisOpportunity) => {
    setCurrentOpportunity(thisOpportunity);
    setShow(true);
  };

  const createNewOpportunity = () => {
    setCurrentOpportunity({
      id: 0,
      description: "",
      status: "Active",
      colour: "#00B3BE",
      opportunityinterested: [],
      type: "System",
    });
    setShow(true);
  };

  function resetInterestedProviders() {
    dispatch(Admin.actions.putResetInterestedProviders({ clientID: currentOpportunity.id, type: "Admin" }));
    setShow(false);
  }

  const columns = [
    { field: "id", headerName: "ID", width: 100, hide: true },
    {
      field: "description",
      headerName: "Description",
      width: 400,
      renderCell: (params) => (
        <strong>
          <div onClick={() => loadOpportunityDetail(opportunities.find((opportunity) => opportunity.id === params.row.id))} className="cell-Link">
            {params.value.substring(0, 100)}
          </div>
        </strong>
      ),
    },
    {
      field: "created",
      headerName: "Created On",
      width: 155,
      sortable: true,
      renderCell: (params) => format(new Date(params.row.created), "dd-MM-yyyy HH:mm:ss a"),
      cellClassName: "grid-mono-font",
    },
    { field: "type", headerName: "Type", width: 120 },
    { field: "firstname", headerName: "Firstname", width: 150 },
    { field: "surname", headerName: "Surname", width: 120 },
    { field: "status", headerName: "Status", width: 150 },
  ];

  function handleClose() {
    setShow(false);
  }

  const handleSearch = (event) => {
    const searchTerm = event.target.value;
    setSearchTerm(searchTerm);
  };

  const validationSchema = Yup.object({
    description: Yup.string().max(500, "Description must be 500 characters or less").required("Description is required"),
  });

  return (
    <>
      <Grid container direction="row" justifyContent="space-between">
        <Grid item>
          <h4 style={{ marginBottom: 12 }}>Opportunity Maintenance</h4>
        </Grid>
      </Grid>

      <Paper>
        <Grid container style={{ padding: 10 }}>
          <Grid item style={{ paddingTop: 2, paddingRight: 10 }}>
            <InputGroup size="sm">
              <InputGroup.Prepend>
                <InputGroup.Text>
                  <SearchIcon fontSize="small" style={{ marginLeft: -4 }} />
                </InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control type="text" value={searchTerm} onChange={(event) => handleSearch(event)} autoComplete="OFF" />
            </InputGroup>
          </Grid>
          <Grid item style={{ paddingRight: 10 }}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="opportunityStatus-label" className={classes.label}>
                Status
              </InputLabel>
              <Select
                labelId="opportunityStatus-label"
                id="opportunityStatus"
                variant="outlined"
                margin="dense"
                value={filters.opportunityStatus}
                onChange={(event) => dispatch(Admin.actions.setFilters({ filterName: "opportunityStatus", filterValue: event.target.value }))}
                style={{ minWidth: 120, backgroundColor: "#ffffff" }}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
              >
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="Closed">Closed</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item style={{ paddingRight: 10 }}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="opportunityType-label" className={classes.label}>
                Type
              </InputLabel>
              <Select
                labelId="opportunityType-label"
                id="opportunityType"
                variant="outlined"
                margin="dense"
                value={filters.opportunityType}
                onChange={(event) => dispatch(Admin.actions.setFilters({ filterName: "opportunityType", filterValue: event.target.value }))}
                style={{ minWidth: 120, backgroundColor: "#ffffff" }}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
              >
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="System">System</MenuItem>
                <MenuItem value="Client">Client</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item>
            <Button variant="primary" size="sm" onClick={() => createNewOpportunity()}>
              Create System Opportunity
            </Button>
          </Grid>
        </Grid>
      </Paper>

      {opportunities ? (
        <Paper style={{ height: 700 }}>
          <DataGrid
            rows={filteredOpportunities}
            columns={columns}
            pageSize={10}
            checkboxSelection={false}
            rowHeight={40}
            sortModel={[{ field: "created", sort: "desc" }]}
          />
        </Paper>
      ) : (
        "None"
      )}

      <Modal show={show} onHide={handleClose} dialogClassName="editprofile-modal">
        <Formik
          enableReinitialize
          validationSchema={validationSchema}
          initialValues={
            currentOpportunity || {
              id: 0,
              description: "",
              status: "Active",
              colour: "#00B3BE",
              opportunityinterested: [],
              type: "System",
            }
          }
          onSubmit={(values) => {
            const payload = {
              id: values.id,
              description: values.description,
              status: values.status,
              colour: values.colour,
            };

            process.env.REACT_APP_DEBUG && console.log("Saving data", payload);

            dispatch(Admin.actions.putOpportunity(payload));

            setShow(false);
          }}
        >
          {({ values, handleChange, handleSubmit, errors, touched }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Header closeButton className="editprofile-modal" style={{ paddingBottom: 0 }}>
                <Modal.Title>{values.id === 0 ? "Create Opportunity" : "Update Opportunity"}</Modal.Title>
              </Modal.Header>

              <Modal.Body className="editprofile-modal">
                <Row>
                  <Col md="12">
                    <Form.Group>
                      <Form.Label>Opportunity Details (Max 500 characters)</Form.Label>

                      <Form.Control
                        as="textarea"
                        rows={4}
                        name="description"
                        value={values.description}
                        onChange={handleChange}
                        autoComplete="new-password"
                        isInvalid={touched.description && !!errors.description}
                      />

                      <div className="d-flex justify-content-between mt-1">
                        <div>{touched.description && errors.description && <div className="text-danger">{errors.description}</div>}</div>

                        <small className={values.description.length >= 450 ? "text-danger" : "text-muted"}>{values.description.length}/500</small>
                      </div>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md="3">
                    <Form.Group>
                      <Form.Label>Colour</Form.Label>

                      <Form.Control as="select" name="colour" value={values.colour} onChange={handleChange}>
                        <option value="#00B3BE">Aqua</option>
                        <option value="#A33383">Magenta</option>
                        <option value="#D2B12B">Yellow</option>
                        <option value="#93A33A">Green</option>
                      </Form.Control>
                    </Form.Group>
                  </Col>

                  <Col md="3">
                    <Form.Group>
                      <Form.Label>Status</Form.Label>

                      <Form.Control as="select" name="status" value={values.status} onChange={handleChange}>
                        <option value="Active">Active</option>
                        <option value="Closed">Closed</option>
                      </Form.Control>
                    </Form.Group>
                  </Col>

                  {values.type === "System" && (
                    <Col md="3" style={{ paddingTop: 26 }}>
                      <Button variant="primary" type="button" onClick={() => resetInterestedProviders()}>
                        Reset Interested Providers
                      </Button>
                    </Col>
                  )}
                </Row>

                <Row>
                  <Col md="9">
                    <Form.Label>Interested Providers</Form.Label>

                    <Paper>
                      <TableContainer
                        style={{
                          backgroundColor: "#FFF",
                          height: 340,
                          width: "100%",
                          overflowY: "scroll",
                        }}
                      >
                        <Table className={classes.table} aria-label="simple table">
                          <TableHead>
                            <TableRow>
                              <TableCell>Provider</TableCell>
                              <TableCell>Expressed Interest</TableCell>
                              <TableCell>Relevant Info</TableCell>
                            </TableRow>
                          </TableHead>

                          <TableBody>
                            {values.opportunityinterested &&
                              values.opportunityinterested.map((row) => (
                                <TableRow key={row.id}>
                                  <TableCell>{row.providerName}</TableCell>

                                  <TableCell>{format(new Date(row.createdOn), "dd-MM-yyyy HH:mm")}</TableCell>

                                  <TableCell>{row.relevantInfo}</TableCell>
                                </TableRow>
                              ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Paper>
                  </Col>
                </Row>
              </Modal.Body>

              <Modal.Footer className="editprofile-modal">
                <Button variant="secondary" type="button" onClick={handleClose}>
                  Cancel
                </Button>

                {values.type === "System" && (
                  <Button variant="primary" type="submit">
                    Save
                  </Button>
                )}
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>

      <ToastContainer
        position="bottom-right"
        transition={Flip}
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}
